import { render, staticRenderFns } from "./BaseInformationForm.vue?vue&type=template&id=fb17ed34&"
import script from "./BaseInformationForm.vue?vue&type=script&lang=ts&"
export * from "./BaseInformationForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports